import { useSelector } from "react-redux";
import { ProjectUsageUpdate } from "@iventis/domain-model/model/projectUsageUpdate";
import { ProjectUsage } from "@iventis/domain-model/model/projectUsage";
import { ProjectUserUsage } from "@iventis/domain-model/model/projectUserUsage";
import { AuthState } from "./auth.slice";

export type UsagePropertyUpdate = keyof Omit<ProjectUsageUpdate, "projectId">;
export type UsageProperty = Exclude<keyof ProjectUsage | keyof ProjectUserUsage, "projectId" | "userId" | "id">;

export const useProjectLimiter = () => {
    const { projectUsage, projectSubscription, subscriptionPlan } = useSelector(({ auth: { projectUsage, projectSubscription, subscriptionPlan } }: { auth: AuthState }) => ({
        projectUsage,
        projectSubscription,
        subscriptionPlan,
    }));
    const { functionality } = subscriptionPlan;

    const canUse = (property: UsageProperty) => {
        switch (property) {
            case "users":
                return projectSubscription.maximumUsers == null || projectUsage.users < projectSubscription.maximumUsers;
            case "teamMaps":
                return functionality.maxTeamMaps == null || (projectUsage.teamMaps < functionality.maxTeamMaps && functionality.sharedWorkspace);
            default:
                throw new Error("Property not supported");
        }
    };
    return [canUse, { projectUsage, functionality, maximumUsers: projectSubscription.maximumUsers }] as const;
};
